import moment from "moment";

export const convertCSVToJson = (csvData, type, ADD_ENTITY_CSV_MAPPING) => {
    const header = csvData[0];
    const dataRows = csvData.slice(1);

    const formattedData = [];
    for (const row of dataRows) {
        const formattedRow = {};
        for (let i = 0; i < header.length; i++) {
            const key = header[i];
            const value = row[i];
            formattedRow[key] = value;
        }
        formattedData.push(formattedRow);
    }

    switch (type) {
        case "save_entity":

        return formattedData.map((x) => {
            const formattedItem = {};
    
            for (const key in ADD_ENTITY_CSV_MAPPING) {
                const newKey = ADD_ENTITY_CSV_MAPPING[key];
                const value = x[key];
                if (value !== undefined) {
                    const keys = newKey.split('.');
                    let temp = formattedItem;
                    for (let i = 0; i < keys.length - 1; i++) {
                        if (!temp[keys[i]]) {
                            temp[keys[i]] = {};
                        }
                        temp = temp[keys[i]];
                    }
                    temp[keys[keys.length - 1]] = value;
                }
            }
            if (formattedItem.categories) {
                formattedItem.categories = formattedItem.categories.split("-");
            }
            return formattedItem;
        });
            break;

        default:
            break;
    }

}

export function formatDate(timestamp) {
    var date = new Date(timestamp);
    var optionsDate = {
        month: 'short',
        day: '2-digit',
        year: 'numeric'
    };
    var formattedDate = date.toLocaleDateString('en-US', optionsDate);
    var optionsTime = {
        hour: 'numeric',
        minute: 'numeric'
    };
    var formattedTime = date.toLocaleTimeString('en-US', optionsTime);
    var ampm = date.getHours() >= 12 ? 'PM' : 'AM';
    var hours12 = date.getHours() % 12;
    hours12 = hours12 ? hours12 : 12;
    formattedTime = hours12 + ':' + ('0' + date.getMinutes()).slice(-2) + ' ' + ampm;
    return formattedDate + ', ' + formattedTime;
}

export const formatDateFromNow = (timestamp) => { 
    return moment(timestamp).fromNow()
}

export function getLocalDateTimeForInput(date = new Date()) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

/**
 * Readable key for an EPM test: its own key when it has one,
 * otherwise one derived from the MongoDB ObjectId.
 * Accepts a test object or an id.
 */
export const formatTestCardId = (testOrId = '') => {
    if (testOrId && typeof testOrId === 'object') {
        if (testOrId.key) return testOrId.key;
        testOrId = testOrId._id || testOrId.id || '';
    }
    return `XCM-${String(testOrId).slice(-4).toUpperCase()}`;
};
